let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1bPTt")).then(() => parcelRequire('72S2k'));